import React, { Fragment } from 'react'
import { observer } from 'mobx-react'
import { IonContent, IonModal, IonHeader, IonFooter } from '@ionic/react'
import { storeMobx } from '@mobxStore'
import './index.scss'

interface IProps {
  type: 'all' | 'area' | 'tax';
  hasStore?: boolean;
  reject?: any;
  resolve?: any;
}

const AddressTipModal: React.FC<IProps> = (props) => {
  const { type, reject, resolve, hasStore } = props
  return (
    <IonModal
      cssClass='address-tip-modal'
      isOpen
      showBackdrop
      onWillDismiss={() => reject()}
      backdropDismiss
    >
      <IonHeader />
      {
        hasStore ? (
          <Fragment key='has-store'>
            <div className='tip-content'>
              <div className='title'>{i18n.t('location.reminder')}</div>
              <div>{i18n.t('newCart.noMatchAddressHasOtherStore')}</div>
            </div>
            <IonFooter>
              <div className='cancel' data-cypid='addressTipModalCancel' onClick={() => reject()}>{i18n.t('location.refreshEdit')}</div>
              <div className='confirm' data-cypid='addressTipModalConfirm' onClick={() => resolve()}>{i18n.t('location.saveAndUse')}</div>
            </IonFooter>
          </Fragment>
        ) : (
          <Fragment key='no-store'>
            <div className='tip-content'>
              <div className='title'>{i18n.t('location.noStoreInAddress2')}</div>
              {type === 'all' && <div>{i18n.t('newCart.noMatchAddressAndTax3')}</div>}
              {type === 'area' && <div>{i18n.t('newCart.noMatchAddress3')}</div>}
              {type === 'tax' && <div>{i18n.t('newCart.noMatchAddressTax3')}</div>}
              <div>{i18n.t('newCart.noMatchAddress33')} {storeMobx.info?.tel && <a className='tel' href={`tel:${storeMobx.info?.tel}`}>{storeMobx.info?.tel}</a>}</div>
            </div>
            <IonFooter>
              <div className='cancel' data-cypid='addressTipModalCancel' onClick={() => resolve()}>{i18n.t('location.saveAgain')}</div>
              <div className='confirm' data-cypid='addressTipModalConfirm' onClick={() => reject()}>{i18n.t('location.refreshEdit')}</div>
            </IonFooter>
          </Fragment>
        )
      }
    </IonModal>
  )
}

export default observer(AddressTipModal)
